export enum ActionTypes {
  DATA_LOADED = 'DATA_LOADED'
}



// WEBPACK FOOTER //
// ./src/store/actions/action-types.ts